import { Component, inject, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule } from "@angular/forms";
import {
  IndividualRelationshipFormGroupComponent
} from "../../reusable-form-groups/relationship-form-group/individual-relationship-form-group.component";
import { CommonModalFormComponent } from "@shared/components/commons/common-modal-form/common-modal-form.component";
import { Guid } from "../../../shared/utils/guid.helper";
import { IndividualData } from "@models/individuals/individual-data";
import { Address } from "../../../models/address/address";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Relationship } from "@models/relationships/relationship";
import { setControlDisabled } from "../../../shared/utils/set-control-disabled";
import { parseFullName } from '../../../shared/utils/parse-fullname';

@Component({
  selector: 'app-form-individual-relationship-modal',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    IndividualRelationshipFormGroupComponent,
    CommonModalFormComponent
  ],
  templateUrl: './form-individual-relationship-modal.component.html',
})
export class FormIndividualRelationshipModalComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);

  @Input() hideAddress = false;
  @Input() nameControlLabel = '';
  @Input() individualRelationship: Relationship | null = null;

  header = '';
  form = IndividualRelationshipFormGroupComponent.defineForm();

  ngOnInit(): void {
    this.activeModal.update({ modalDialogClass: 'common-modal-form-dialog overflow-y-auto' });
    if (!this.individualRelationship) {
      this.individualRelationship = new Relationship({
        individualDataOverride: new IndividualData({
          address: new Address(this.form.controls.address as Partial<Address>)
        })
      });
    } else {
      this.form.patchValue({
        name: this.individualRelationship.individualDataOverride?.fullName,
        address: this.individualRelationship.individualDataOverride?.address
      });
    }

    setControlDisabled(this.form.controls.address, this.hideAddress);
  }

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const individualRelationship = new Relationship({
      ...this.individualRelationship,
      individualDataOverride: new IndividualData({
        ...parseFullName(this.form.controls.name.value ?? ''),
        address: new Address(this.form.controls.address.value as Partial<Address>)
      })
    });

    this.activeModal.close(individualRelationship);
  }

  cancel(): void {
    setControlDisabled(this.form);
    this.activeModal.dismiss();
  }
}
